import { CatDoc } from "@shared/models/cat.model";
import { PaginationParams } from "@shared/models/common";
import { ClaimReferenceDetails } from "./claim-reference-details";


export class ClaimsViewModel {

    claimId!: number;
    phraseContentType!: string;
    status!: string;
    catSubVersionId!: number;
    claimVersionId!: number;
    catPhraseId!: number;
    mainText!: string;
    docs!: CatDoc[];
    statement!: string;
    references!: ClaimReference[];
    footnotes!: ClaimFootnote[];
    associatedText!: ClaimAssocText[];
    metadata!: ClaimDocMetadata[];
    isSelected!: boolean;
}

export class CreateClaimDto {
    mainText!: string;
    associatedText!: string[];
    footnotes!: string[];
    references!: {
        refDocId: number | null;
        refCitation: string | null;
        refDocAnchorsIds: number[]
    }[];
    status!: string;
    metadata!: { [key: string]: string[] } | null;
    catVersionId!: number;
    claimType!: string;

}

export class EditClaimDto {
    mainText!: string;
    associatedText!: string[];
    footnotes!: string[];
    references!: {
        refDocId: number | null;
        refCitation: string | null;
        refDocAnchorsIds: number[]
    }[];
    metadata!: { [key: string]: string[] } | null;
    claimType!: string;

}

export class ClaimFormModel {

    claimText!: string;
    claimId?: number;
    associatedText!: ClaimAssocText[];
    footnotes!: ClaimFootnote[];
    references: ClaimReferenceDetails[] | null = null;
    catVersionId!: number;
    metadata?: ClaimDocMetadata[];
    status!: string;
    contentType!: string;

}

export class ClaimReference {

    refPhraseText!: string;
    anchorPath!: string;
}


export class ClaimReferenceDto {

    ref_text!: string;
    anchor_paths!: string;
}

export class ClaimFootnote {
    
    footnoteText!: string;
}

export class ClaimAssocText {
    assocPhraseText!: string;
}

export class ClaimDocMetadata {


    fieldLabel!: string;
    fieldName!: string;
    fieldValues!: string[];


}

export class ClaimsViewSearchParams extends PaginationParams {

    constructor() {
        
        super();
    }
}

export class ClaimsViewInfo {

    claims!: ClaimsViewModel[];
    claimsStats!: ClaimsViewStats;
}

export class ClaimsViewStats {

    totalCount!: number;
}
export class ClaimsViewInfoDto {

    claims!: ClaimsViewModelDto[];
    totalCount!: number;
    fromRec!: number;
    toRec!: number;
}
export class ClaimsViewModelDto {


    claim_id!: number;
    cat_sub_version_id!: number;
    cat_phrase_id!: number;
    main_text!: string;
    phrase_content_type!: string;
    claim_version_id!: number;
    statement!: string;
    status!: string;
    references!: ClaimReferenceDto[];
    footnotes!: string[];
    assoc_text!: string[];
    metadata!:  ClaimDocMetadataDto[]
    documents!: ClaimCatDocDto[];  

}

export class ClaimCatDocDto {

    cat_id!: number;
    cat_phrase_id!: number;
    cat_version_id!: number;
    cr_date!: string;
    doc_id!: number;
    doc_name!: string;
    doc_s3_key!: string;
    file_name!: string;
    lang!: string;
    out_json!: string;
    page_num!: number;
    page_pdf_s3_key!: string;
    page_pdf_url!: string;
    pages_cnt!: number;
    phrase_el!: string;
    phrase_id!: number;
    phrase_page_url!: string;
    version_id!: number;
    x1!: number;
    x2!: number;
    y1!: number;
    y2!: number;
}

export class ClaimDocMetadataDto {
    
    field_label!: string;
    field_name!: string;
    field_values!: string[] | {
        value_code: string;
        value_label: string;
    }[];
}

